var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSkrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.152,
    height: 40.426,
    viewBox: "0 0 54.152 40.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 54.152,
    height: 40.426,
    fill: "#c4e7f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-skrill",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M44.752,0A61.156,61.156,0,0,1,33.645,6.138,92.057,92.057,0,0,1,21.9,10.347,112.418,112.418,0,0,0,6.319,15.953C2.529,17.606,0,18.9,0,18.9l9.4,21.53s2.528-1.29,6.319-2.944a112.418,112.418,0,0,1,15.576-5.605,89.928,89.928,0,0,0,11.964-4.235,55.581,55.581,0,0,0,10.894-6.113ZM5.224,24.975,3.064,20.025c1.066-.507,2.508-1.175,4.2-1.913.349-.152.719-.312,1.1-.473a8.847,8.847,0,0,1-3.136,7.336m9.55,10.347c-1.683.734-3.114,1.4-4.2,1.909l-2.2-5.042a8.9,8.9,0,0,1,7.2,2.786c-.275.118-.544.233-.8.347m3.919-9.252a2.4,2.4,0,1,1-.167-3.388,2.4,2.4,0,0,1,.167,3.388m11.8,1.374c-2.715,1.186-6.193-.782-7.77-4.394s-.654-7.5,2.059-8.684,6.193.782,7.77,4.392.654,7.5-2.059,8.686m9.243-9.615a2.4,2.4,0,1,1-.167-3.388,2.4,2.4,0,0,1,.167,3.388M38.633,6.4c1.832-.926,3.534-1.881,5.091-2.864L46.155,9.1a8.86,8.86,0,0,1-7.522-2.7m10.516,9.564,2.076,4.754a49.7,49.7,0,0,1-5.06,2.947,8.958,8.958,0,0,1,2.984-7.7",
    transform: "translate(0 -0.001)",
    fill: "#c4e7f8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSkrill);
export default __webpack_public_path__ + "static/media/icon-skrill.cbe346540ae14200d0ccd1dacf09bde0.svg";
export { ForwardRef as ReactComponent };